import React from 'react';

export const IconBarChart: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
        <rect x="1.5" y="9" width="3" height="5.5" rx="0.5" stroke="currentColor" strokeWidth="1.25" />
        <rect x="6.5" y="5" width="3" height="9.5" rx="0.5" stroke="currentColor" strokeWidth="1.25" />
        <rect x="11.5" y="1.5" width="3" height="13" rx="0.5" stroke="currentColor" strokeWidth="1.25" />
    </svg>
);
